
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({ name: 'svg-icon' })
export default class indexView extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  name!: string

  @Prop({
    type: String,
    default: '',
  })
  svgClass!: string

  get iconName() {
    return `#icon-${this.name}`
  }
}
